export enum InternalContentComponentType {
  INLINE_IMAGE_WRAPPER_COMPONENT = 'ppg_internal_inline_image_wrapper_component',
}
